import SectionRegions from '../../../../containers/LandingPage/SectionRegions';
import { withBaseComponent } from '../../hoc/withBaseComponent';

const StoryblokRegionsWomoPreset = () => {
  return <SectionRegions />;
};

export default withBaseComponent(StoryblokRegionsWomoPreset);
